import { render, staticRenderFns } from "./RedeCredenciada.vue?vue&type=template&id=112a2c3b&"
import script from "./RedeCredenciada.vue?vue&type=script&lang=js&"
export * from "./RedeCredenciada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports